import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import type { NumberFormatValues } from 'react-number-format';
import { NumericFormat } from 'react-number-format';
import type { PpInputFieldAtom } from './atoms/InputFieldAtom';
import { InputFieldAtom } from './atoms/InputFieldAtom';

type TpInputFieldAtomProps = Omit<
  PpInputFieldAtom,
  'ref' | 'value' | 'defaultValue' | 'type' | 'size'
>;

export type PpFormatInputField = {
  InputFieldAtomProps: TpInputFieldAtomProps;
  className?: string;
};
export function FormatInputField({
  className,
  InputFieldAtomProps,
}: PpFormatInputField): React.ReactElement {
  const { formState, getValues, setValue } = useFormContext();

  const handleValueChange = useCallback(
    (values: NumberFormatValues) => {
      setValue(InputFieldAtomProps.name, values.value, { shouldValidate: true });
    },
    [InputFieldAtomProps.name, setValue],
  );

  return (
    <NumericFormat
      thousandSeparator
      allowNegative={false}
      className={className}
      customInput={InputFieldAtom}
      errorMessage={formState.errors[InputFieldAtomProps.name]?.message?.toString()}
      value={getValues(InputFieldAtomProps.name)}
      onValueChange={handleValueChange}
      {...InputFieldAtomProps}
    />
  );
}
